import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74bd4dec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "カルテNo.", -1))
const _hoisted_2 = { class: "col-8 td" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "LINEアカウント", -1))
const _hoisted_4 = { class: "col-8 td" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "名前", -1))
const _hoisted_6 = { class: "col-8 td" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "生年月日", -1))
const _hoisted_9 = { class: "col-8 td" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "電話番号", -1))
const _hoisted_11 = { class: "col-8 td" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "住所", -1))
const _hoisted_13 = { class: "col-8 td" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "メールアドレス", -1))
const _hoisted_16 = { class: "col-8 td" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "初回来店日", -1))
const _hoisted_18 = { class: "col-8 td" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "最終来店日", -1))
const _hoisted_24 = { class: "col-8 td" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "過去来店回数", -1))
const _hoisted_27 = { class: "col-8 td" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 th" }, "来店周期日数", -1))
const _hoisted_30 = { class: "col-8 td" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "grid mx-0 flex-grow-1" }
const _hoisted_33 = { class: "col-12 p-0" }

import moment from "moment";
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { ICustomer, ITag } from "@/clinic/typings";
import CustomerNote from "@/clinic/components/CustomerNote.vue";
import { linkedLineStatus } from "@/clinic/typings/enums/customer";
import { CALCULATOR_HEIGHT_DIRECT_MESSAGE_NOTE } from "@/clinic/typings/constants/clinic";
import { CustomerStatusesConstants } from "@/clinic/constants/customer.constants";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
    clinicId: null,
    customer: null,
    listTags: null,
    tags: null
  },
  setup(__props: any) {

const props = __props as {
  clinicId: number;
  customer: ICustomer;
  listTags: ITag[];
  tags: ITag[];
};

const store = useStore();


const headerProfile = ref();
const messageContainer = ref();
const headerProfileHeight = ref(0);
const messageContainerHeight = ref(0);
let calculatorHeightValue = ref(0);
const calculatorHeight = () => {
  const customer = props.customer;
  return !customer.zipcode && !customer.address ? 0 : CALCULATOR_HEIGHT_DIRECT_MESSAGE_NOTE;
};
const accountLinkedLineStatus = computed(() => {
  return props.customer.line_account_ids && props.customer.line_account_ids.length > 0
    ? linkedLineStatus.linked
    : linkedLineStatus.notYet;
});

onMounted(async () => {
  await nextTick();
  if (messageContainer.value && headerProfile.value) {
    headerProfileHeight.value = headerProfile.value.clientHeight + calculatorHeightValue.value;
    messageContainerHeight.value = messageContainer.value.clientHeight;
  }
});
watch(
  () => {
    return props.customer;
  },
  () => {
    calculatorHeightValue.value = calculatorHeight();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "message-container h-full flex-column flex",
    ref_key: "messageContainer",
    ref: messageContainer
  }, [
    _createElementVNode("div", {
      class: "grid m-0",
      ref_key: "headerProfile",
      ref: headerProfile
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, _toDisplayString(props.customer.code), 1),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(accountLinkedLineStatus)), 1),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(props.customer.name) + " ", 1),
        _hoisted_7,
        _createElementVNode("span", {
          class: _normalizeClass(["inline-block customer-status border-round-xl text-center mr-1 px-2 mt-1", props.customer.status])
        }, _toDisplayString(props.customer.status_display_name || _unref(CustomerStatusesConstants)[props.customer.status]), 3)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, _toDisplayString(props.customer.birthday), 1),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, _toDisplayString(props.customer.phone), 1),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createTextVNode(_toDisplayString(props.customer.zipcode) + " ", 1),
        _hoisted_14,
        _createTextVNode(" " + _toDisplayString(props.customer.address) + " " + _toDisplayString(props.customer.address_number), 1)
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, _toDisplayString(props.customer.email), 1),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        (props.customer.first_time_visit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createTextVNode(_toDisplayString(props.customer.first_time_visit ? _unref(moment)(props.customer.first_time_visit).format("YYYY年MM月DD日") : null) + " ", 1),
              (props.customer.time_since_first_visit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _createTextVNode(" ( "),
                    (props.customer.time_since_first_visit[0] != 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(props.customer.time_since_first_visit[0]) + "年 ", 1))
                      : _createCommentVNode("", true),
                    (props.customer.time_since_first_visit[1] != 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(props.customer.time_since_first_visit[1]) + "ヶ", 1))
                      : _createCommentVNode("", true),
                    _createTextVNode("月経過） ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        (props.customer.latest_time_visit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(moment)(props.customer.latest_time_visit).format("YYYY年MM月DD日")) + " (" + _toDisplayString(props.customer.days_since_last_visit) + " 日経過) ", 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        (props.customer.number_of_visit > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(props.customer.number_of_visit) + "回", 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        (props.customer.visit_cycle_in_one_year)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, "平均" + _toDisplayString(props.customer.visit_cycle_in_one_year) + "日", 1))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        (props.customer.id)
          ? (_openBlock(), _createBlock(CustomerNote, {
              key: 0,
              "customer-id": props.customer.id || 0,
              "clinic-id": props.clinicId,
              "header-profile-height": headerProfileHeight.value,
              "message-container-height": messageContainerHeight.value,
              disabled: _unref(store).getters['authClient/selectedClinic'].partner != _unref(ClinicPartner).Unaffiliated
            }, null, 8, ["customer-id", "clinic-id", "header-profile-height", "message-container-height", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}
}

})